import React, { useCallback, useRef, useState, useLayoutEffect } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { CountryCode } from '../..';
import { Container, HiddenSearchInput, NoResults, Items, Item, 
//  ItemCode 
} from './styles';
import { NoArrow, Code, Flag, InputArea } from '../../styles';

interface Props {
  show: boolean;
  value: CountryCode;
  countries?: CountryCode[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: CountryCode) => void;
  onClose: () => void;
}

interface OptionProps {
  className: string;
  code: string;
  name: string;
  flag?: string;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const Option = ({ code, name, flag, ...rest }: OptionProps) => (
  <Item {...rest}>
    <InputArea>
      {flag && <Flag src={flag} alt="flag" />}
      <Code>{code}</Code>
      <NoArrow />
    </InputArea>
    {/*<ItemCode>{flag && <Flag src={flag} alt="flag" />}{code}</ItemCode>*/}
     {name}
  </Item>
);

const LETTERS_REGEX = /[^A-Za-záéíóúàèìòùâêîôûäëïöüãẽĩõũÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÃẼĨÕŨnÑçÇ ]/g;

const CountryCodeOptions = ({ show, countries, selectRef, value, onChange, onClose }: Props) => {
  const { t } = useStoreTranslation();

  const [searchText, setSearchText] = useState<string>('');
  const searchRef = useRef<HTMLInputElement>(null);

  useOutsideClick(selectRef, onClose);
  useLayoutEffect(() => {
    if (show && searchRef.current) searchRef.current.focus();
    else setSearchText('');
  }, [show]);

  const isActive = useCallback((item: CountryCode) => item.id === value.id, [value]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value.replace(LETTERS_REGEX, '').trim());
  };

  const handleItemClick = (country: CountryCode) => {
    if (country.id !== value.id) {
      onChange(country);
    }
    onClose();
  };

  const filteredList = (countries || []).filter((country) => {
  const text = searchText.toLowerCase();
  return (
    country.name.toLowerCase().includes(text) ||
    country.code.toLowerCase().includes(text)
  );
});
  /*const filteredList = (countries || []).filter((country) =>
    country.name.toLowerCase().includes(searchText.toLowerCase()),
  );*/

  return show ? (
    <Container>
      <HiddenSearchInput placeholder='' ref={searchRef} onChange={handleSearchChange} />
      <Items>
        {filteredList.length === 0 ? (
          <NoResults>{t('countryCodeSelect.empty')}</NoResults>
        ) : (
          filteredList.map((country) => (
            <Option
              key={country.id}
              className={isActive(country) ? 'active' : ''}
              code={country.code}
              name={country.name}
              flag={country.flag}
              onClick={() => handleItemClick(country)}
            />
          ))
        )}
      </Items>
    </Container>
  ) : null;
};

export default CountryCodeOptions;
